module.exports = __webpack_public_path__ + "img/selected1-min.03809e4f.png";